// Centralized data-testid registry for Asirox premium site
export const NAV = {
  brand: "nav-brand-asirox",
  link_home: "nav-link-home",
  link_machines: "nav-link-machines",
  link_technology: "nav-link-technology",
  link_sectors: "nav-link-sectors",
  link_cases: "nav-link-cases",
  link_blog: "nav-link-blog",
  link_contact: "nav-link-contact",
  link_assistant: "nav-link-assistant",
  cta_demo: "nav-cta-demo",
  mobile_toggle: "nav-mobile-toggle",
};

export const HERO = {
  title: "hero-title",
  cta_demo: "hero-cta-demo",
  cta_catalog: "hero-cta-catalog",
  cta_quote: "hero-cta-quote",
  scroll_indicator: "hero-scroll-indicator",
};

export const MACHINES_PAGE = {
  container: "machines-page",
  card: (slug) => `machine-card-${slug}`,
  card_link: (slug) => `machine-card-link-${slug}`,
};

export const MACHINE_DETAIL = {
  container: "machine-detail",
  cta_demo: "machine-cta-demo",
  cta_quote: "machine-cta-quote",
  tab_specs: "machine-tab-specs",
  tab_applications: "machine-tab-applications",
  tab_faq: "machine-tab-faq",
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-input-name",
  email: "contact-input-email",
  phone: "contact-input-phone",
  company: "contact-input-company",
  sector: "contact-select-sector",
  interest: "contact-select-interest",
  message: "contact-input-message",
  submit: "contact-submit",
  whatsapp: "contact-whatsapp",
};

export const ASSISTANT = {
  open_widget: "assistant-open-widget",
  panel: "assistant-panel",
  input: "assistant-input",
  send: "assistant-send",
  message: (i) => `assistant-message-${i}`,
  page_input: "assistant-page-input",
  page_send: "assistant-page-send",
};

export const BLOG = {
  card: (slug) => `blog-card-${slug}`,
  article: "blog-article",
};

export const CASES_TESTS = {
  card: (id) => `case-card-${id}`,
};

export const SECTORS_TESTS = {
  card: (key) => `sector-card-${key}`,
};
